// extracted by mini-css-extract-plugin
export default {"infiniteScroll":"MyPatients_infiniteScroll__vMP7f"};